import * as React from 'react';
import getStore from 'owa-calendar-sharing/lib/store/store';
import { CalendarSharingDialogComponent } from 'owa-calendar-sharing';
import { hideCalendarSharingPermissionsDialog } from 'owa-calendar-sharing/lib/actions/calendarSharing';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { observer } from 'mobx-react';
/**
 *  Modal wrapper for Calendar sharing component
 */
export default observer(function CalendarUpdatesSection() {
    var onDismissCalendarSharingPermissions = function () {
        hideCalendarSharingPermissionsDialog();
    };
    return getStore().viewState ? (React.createElement(Modal, { isOpen: true, onDismiss: onDismissCalendarSharingPermissions, isClickableOutsideFocusTrap: true, firstFocusableSelector: "ms-BasePicker-input", isBlocking: false },
        React.createElement(CalendarSharingDialogComponent, { folderId: getStore().viewState.folderId }))) : null;
});
//# sourceMappingURL=CalendarSharingPermissionsModalRenderer.js.map